<template>
  <b-row>
    <b-col cols="12">
      <h3 class="mb-3 hp-text-color-black-1">Клиенты</h3>
    </b-col>
    
    <b-col>
      <ClientsTable />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BButton } from "bootstrap-vue";

import ClientsTable from "./ClientsTable.vue";

export default {
  data() {
    return {};
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    ClientsTable,
  },
  methods: {},
};
</script>
